var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("通知公告")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.list,
              "cell-style": { padding: "4px" },
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "序号", width: "50", type: "index" },
            }),
            _c("el-table-column", {
              attrs: { prop: "noticeTitle", label: "公告标题", width: "120px" },
            }),
            _c("el-table-column", {
              attrs: { label: "公告内容" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      !scope.row.customerChannelUser
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(scope.row.noticeContent),
                            },
                          })
                        : _vm._e(),
                      scope.row.customerChannelUser &&
                      scope.row.noticeContent != "自动同步"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                " 订单号：" +
                                  _vm._s(
                                    scope.row.customerChannelUser.orderNo
                                  ) +
                                  " , "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "red",
                                    display: "inline-block",
                                    margin: "0 10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 订单状态：" +
                                      _vm._s(
                                        scope.row.customerChannelUser
                                          .orderStatus
                                      ) +
                                      " , "
                                  ),
                                ]
                              ),
                              _vm._v(
                                " 平台:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.platformName
                                  ) +
                                  " , 渠道:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.channelName
                                  ) +
                                  " , 客户名字:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.customerName
                                  ) +
                                  " , 电话:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.customerPhone
                                  ) +
                                  " , 入线时间:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.orderTimeStr
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                " 客户信息：" +
                                  _vm._s(
                                    scope.row.customerChannelUser.comment
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                " 商品：" +
                                  _vm._s(
                                    scope.row.customerChannelUser.prodName
                                  ) +
                                  " " +
                                  _vm._s(
                                    scope.row.customerChannelUser.prodItem
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                " 商品数量：" +
                                  _vm._s(
                                    scope.row.customerChannelUser.prodNumber
                                  ) +
                                  " 商品价格：" +
                                  _vm._s(
                                    scope.row.customerChannelUser.prodPrice
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "red",
                                    display: "inline-block",
                                    margin: "0 10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 商品总价：" +
                                      _vm._s(
                                        scope.row.customerChannelUser.totalMoney
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            scope.row.customerChannelUser &&
                            scope.row.customerChannelUser.orderNo
                              ? _c(
                                  "span",
                                  { staticStyle: { "margin-right": "5px" } },
                                  [
                                    _vm._v(
                                      "收货电话:" +
                                        _vm._s(
                                          scope.row.customerChannelUser
                                            .addressPhone
                                            ? scope.row.customerChannelUser
                                                .addressPhone
                                            : scope.row.customerChannelUser
                                                .customerPhone
                                        )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("span", [
                              _vm._v(
                                "收货地址:" +
                                  _vm._s(scope.row.customerChannelUser.address)
                              ),
                            ]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  display: "inline-block",
                                  margin: "0 10px",
                                },
                              },
                              [
                                _vm._v(
                                  " 支付状态：" +
                                    _vm._s(
                                      scope.row.customerChannelUser.payTypeLabbl
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                "留言：" +
                                  _vm._s(
                                    scope.row.customerChannelUser
                                      .customerMessage
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      scope.row.customerChannelUser &&
                      scope.row.noticeContent == "自动同步"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                " 平台:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.platformName
                                  ) +
                                  ", 渠道:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.channelName
                                  ) +
                                  ", 客户名字:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.customerName
                                  ) +
                                  ", 电话:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.customerPhone
                                  ) +
                                  ", 入线时间:" +
                                  _vm._s(
                                    scope.row.customerChannelUser.orderTimeStr
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("p", [_vm._v("详情请到“我的客户”查看详情")]),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "noticeTypeName",
                label: "公告类型",
                width: "120px",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "statusName", label: "状态", width: "120px" },
            }),
            _c("el-table-column", {
              attrs: { label: "创建时间", width: "110px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.createdTime ? scope.row.createdTime : "-"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "操作", center: "", width: "150px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.parArray.indexOf("noticeDel") != -1
                        ? _c(
                            "p",
                            {
                              staticClass: "operation",
                              on: {
                                click: function ($event) {
                                  return _vm.delect(scope.row, scope.$index)
                                },
                              },
                            },
                            [_vm._v(" 删除 ")]
                          )
                        : _vm._e(),
                      scope.row.type == "1" &&
                      _vm.parArray.indexOf("noticeAddOrder") != -1
                        ? _c(
                            "p",
                            {
                              staticClass: "operation",
                              on: {
                                click: function ($event) {
                                  return _vm.addCursom(scope.row)
                                },
                              },
                            },
                            [_vm._v(" 客户资料 ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticStyle: { height: "40px" } }),
    _vm.tableData.totalNum >= 1
      ? _c("div", { staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage1,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.totalNum,
                  "prev-text": "上一页",
                  "next-text": "下一页",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }